var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/vue2-google-maps/~/core-js/library/modules/$.has.js
// module id = 64
// module chunks = 1